/**
 * VP-206: limity współbieżności generowania. Współdzielone między API
 * (guard odrzucający nadmiarowe joby) a frontendem (blokada przycisku,
 * zanim request w ogóle poleci) — jedna stała, zero rozjazdu.
 */
export const MAX_CONCURRENT_AD_GRAPHIC_JOBS = 3;

/**
 * Joby starsze niż to okno nie liczą się do limitu współbieżności. Reaper
 * osieroconych jobów działa tylko przy starcie procesu, więc bez tego okna
 * job "generating" osierocony przez crash blokowałby userowi slot na zawsze.
 * Wartość = STALE_JOB_MS reapera (2h, patrz jobs-service.ts).
 */
export const ACTIVE_JOB_MAX_AGE_MS = 2 * 60 * 60 * 1000;
